import { useQuery } from "react-query";
import {
  EntityOptionsSource,
  getRecordEntityOptions,
} from "src/utils/api/dashboard";

export const useRecordEntityOptions = (
  source: EntityOptionsSource,
  filters: Record<string, any>,
  enabled = true
) => {
  const { data, isFetching } = useQuery(
    ["recordEntityOptions", source, filters],
    () => getRecordEntityOptions(source, filters),
    { staleTime: 60 * 1000, enabled }
  );
  return { entityInfo: data?.data?.rows ?? [], isFetching };
};
